module.exports = __webpack_public_path__ + "static/media/serverinsights.6e8734cb.png";